export default __webpack_public_path__ + "static/media/motion-board.50c65a93.jpg";